module.exports = __webpack_public_path__ + "img/es-active.8f68d947.png";